module.exports = __webpack_public_path__ + "img/gouwuche.13927e3c.png";